import { i18n } from '@/plugins/i18n'

const stateKey = (s) => String(s || '').replace(/\./g, '_')
const configName = (section, value, fallback = '') => {
  if (value === undefined || value === null || value === '') return fallback

  const key = `config.${section}.${value}`
  return i18n.te(key) ? i18n.t(key) : fallback
}
const configStateName = (section, state, fallback = '') => {
  const key = stateKey(state)
  return key ? configName(section, key, fallback) : fallback
}

export const TRIAL_DURATIONS = [
  { duration: { value: 1, unit: 'WEEK' }, value: '1weeks' },
  { duration: { value: 2, unit: 'WEEK' }, value: '2weeks' }
]
export const DURATIONS = [
  { duration: { value: 1, unit: 'MONTH' }, value: '1month' },
  { duration: { value: 2, unit: 'MONTH' }, value: '2month' },
  { duration: { value: 3, unit: 'MONTH' }, value: '3month' },
  { duration: { value: 6, unit: 'MONTH' }, value: '6months' },
  { duration: { value: 12, unit: 'MONTH' }, value: '12months' },
  { duration: { value: 24, unit: 'MONTH' }, value: '24months' }
]
export const ALL_DURATIONS = [...DURATIONS, ...TRIAL_DURATIONS]
export const getDurationName = (value) => configName('durations', value)
export const getDurationObject = (value) => ALL_DURATIONS.find(({ value: key }) => value === key)?.duration
export const getDurationNameFromObject = (duration) => {
  if (!duration) return ''

  const item = ALL_DURATIONS.find(({ duration: d }) => d.value === duration.value && d.unit === duration.unit)
  return item ? getDurationName(item.value) : ''
}

export const DISCOUNTS = [
  { value: 3 },
  { value: 5 }
]

export const DISCOUNTS_SETUP = [
  { value: 50 },
  { value: 100 }
]
export const PRICELISTS = [
  { value: 'STANDARD' },
  { value: 'CH' },
  { value: 'VOBA' },
  { value: 'REMAX' }
]
export const getPricelistName = (value) => configName('pricelists', value, value || '')

export const DOCUMENT_TYPES = [
  { value: 'AVV' },
  { value: 'OBF' },
  { value: 'SEPA' },
  { value: 'OTHER' },
  { value: 'CANCELLATION' },
  { value: 'CONTRACT' }
]
export const getDocumentTypeName = (value) => configName('documentTypes', value, value || '')

export const CANCELLATION_REASONS = [
  { value: 'OTHER' },
  { value: 'UNHAPPY' },
  { value: 'SUPPLIERCHANGE' },
  { value: 'BANKRUPT' },
  { value: 'BADLEADQUALITY' },
  { value: 'NOSUCCESS' },
  { value: 'NOTUNDERSTOOD' },
  { value: 'PROFORMA' }
]
export const getCancellationReasonName = (value) => configName('cancellationReasons', value, value || '')

export const PRODUCT_TYPES = {
  SETUP: 'SETUP',
  EXPERT: 'EXPERT',
  PERFORMANCE: 'PERFORMANCE',
  WEBSITE: 'WEBSITE',
  CREDIT: 'CREDIT',
  BASIC: 'BASIC',
  REMINDER_FEE: 'REMINDER_FEE'
}

export const PAYMENT_METHODS = [
  { value: 'INVOICE' },
  { value: 'DIRECT_DEBIT' },
  { value: 'PREPAYMENT' },
  { value: 'BILLWERK' }
]
export const getPaymentMethodsName = (value) => configName('paymentMethods', value, value || '')

export const SOCIAL_TYPES = [
  { value: 'INSTAGRAM' },
  { value: 'FACEBOOK' },
  { value: 'LINKEDIN' },
  { value: 'TWITTER' },
  { value: 'OTHER' }
]
export const getSocialTypesName = (value) => configName('socialTypes', value, value || '')

export const COUNTRIES_FOR_ADDRESS = [
  { value: 'DE' },
  { value: 'CH' },
  { value: 'AT' },
  { value: 'TR' },
  { value: 'US' }
]

export const COUNTRIES_FOR_COMPANY = [
  { value: 'de' },
  { value: 'ch' },
  { value: 'at' },
  { value: 'tr' },
  { value: 'gb' },
  { value: 'us' },
  { value: 'al' },
  { value: 'ad' },
  { value: 'by' },
  { value: 'be' },
  { value: 'ba' },
  { value: 'bg' },
  { value: 'hr' },
  { value: 'cy' },
  { value: 'cz' },
  { value: 'dk' },
  { value: 'ee' },
  { value: 'fi' },
  { value: 'fr' },
  { value: 'gr' },
  { value: 'hu' },
  { value: 'is' },
  { value: 'ie' },
  { value: 'it' },
  { value: 'lv' },
  { value: 'li' },
  { value: 'lt' },
  { value: 'lu' },
  { value: 'mt' },
  { value: 'md' },
  { value: 'mc' },
  { value: 'me' },
  { value: 'nl' },
  { value: 'mk' },
  { value: 'no' },
  { value: 'pl' },
  { value: 'pt' },
  { value: 'ro' },
  { value: 'ru' },
  { value: 'sm' },
  { value: 'rs' },
  { value: 'sk' },
  { value: 'si' },
  { value: 'es' },
  { value: 'se' },
  { value: 'ua' }
]

export const COUNTRIES = {
  de: 'de',
  ch: 'ch',
  at: 'at',
  tr: 'tr',
  gb: 'gb',
  us: 'us',
  al: 'al',
  ad: 'ad',
  by: 'by',
  be: 'be',
  ba: 'ba',
  bg: 'bg',
  hr: 'hr',
  cy: 'cy',
  cz: 'cz',
  dk: 'dk',
  ee: 'ee',
  fi: 'fi',
  fr: 'fr',
  gr: 'gr',
  hu: 'hu',
  is: 'is',
  ie: 'ie',
  it: 'it',
  lv: 'lv',
  li: 'li',
  lt: 'lt',
  lu: 'lu',
  mt: 'mt',
  md: 'md',
  mc: 'mc',
  me: 'me',
  nl: 'nl',
  mk: 'mk',
  no: 'no',
  pl: 'pl',
  pt: 'pt',
  ro: 'ro',
  ru: 'ru',
  sm: 'sm',
  rs: 'rs',
  sk: 'sk',
  si: 'si',
  es: 'es',
  se: 'se',
  ua: 'ua'
}

export const LINK_LABELS = [
  { key: 'website' },
  { key: 'imprint' },
  { key: 'about' },
  { key: 'privacy' }
]

export const COMPANY_STATE_EVENTS = [
  { value: 'ONBOARDING' },
  { value: 'SELF_ONBOARDING' },
  { value: 'NEXT' },
  { value: 'TRIAL' },
  { value: 'IDLE' },
  { value: 'ONBOARDED' },
  { value: 'PAYMENT_DELAYED' },
  { value: 'PAID' },
  { value: 'DEACTIVATE' },
  { value: 'DEACTIVATE_PAYMENT_DELAY' },
  { value: 'ACTIVATE' }
]
export const getCompanyStateEventName = (value) => configName('companyStateEvents', value, value || '')

export const COMPANY_STATUSES = [
  { value: 'Mandant' },
  { value: 'Hauptfirma' }
]
export const getCompanyStatuses = () => COMPANY_STATUSES.map(s => ({ ...s, name: configName('companyStatuses', s.value, s.value) }))

export const COMPANY_STATES = [
  { value: 'CREATED' },
  { value: 'SELF_ONBOARDING.WEBSITE' },
  { value: 'SELF_ONBOARDING.BILLING' },
  { value: 'ONBOARDING' },
  { value: 'ACTIVE.IDLE' },
  { value: 'ACTIVE.TRIAL' },
  { value: 'ACTIVE.PAYMENT_DELAY' },
  { value: 'INACTIVE.PAYMENT_DELAY' },
  { value: 'INACTIVE.IDLE' }
]

export const COMPANY_STATES_INFO = [
  { value: 'CREATED' },
  { value: 'ONBOARDING' },
  { value: 'ACTIVE.IDLE' },
  { value: 'ACTIVE.TRIAL' },
  { value: 'ACTIVE.PAYMENT_DELAY' },
  { value: 'INACTIVE.PAYMENT_DELAY' },
  { value: 'INACTIVE.IDLE' }
]

export const COMPANY_STATES_INFO_NEXT = [
  { value: 'CREATED' },
  { value: 'ONBOARDING' },
  { value: 'ACTIVE.IDLE' },
  { value: 'ACTIVE.CANCELLED' },
  { value: 'ACTIVE.PAYMENT_DELAY' },
  { value: 'INACTIVE.PAYMENT_DELAY' },
  { value: 'INACTIVE.IDLE' }
]
export const getCompanyStatesName = (state) => configStateName('companyStates', state, state || '')
export const getCompanyStatesInfo = (state) => configStateName('companyStatesInfo', state)
export const getCompanyStatesNextInfo = (state) => configStateName('companyStatesNextInfo', state)
export const getCompanyStates = () => COMPANY_STATES.map(s => ({ ...s, name: getCompanyStatesName(s.value) }))

export const getDurations = () => DURATIONS.map(d => ({ ...d, name: getDurationName(d.value) || d.value }))
export const getTrialDurations = () => TRIAL_DURATIONS.map(d => ({ ...d, name: getDurationName(d.value) || d.value }))
export const getAllDurations = () => ALL_DURATIONS.map(d => ({ ...d, name: getDurationName(d.value) || d.value }))
export const getDiscounts = () => DISCOUNTS.map(d => ({ ...d, name: configName('discounts', d.value, String(d.value)) }))
export const getDiscountsSetup = () => DISCOUNTS_SETUP.map(d => ({ ...d, name: configName('discountsSetup', d.value, String(d.value)) }))
export const getPricelists = () => PRICELISTS.map(p => ({ ...p, name: getPricelistName(p.value) }))
export const getDocumentTypes = () => DOCUMENT_TYPES.map(t => ({ ...t, name: getDocumentTypeName(t.value) }))
export const getCancellationReasons = () => CANCELLATION_REASONS.map(r => ({ ...r, name: getCancellationReasonName(r.value) }))
export const getPaymentMethods = () => PAYMENT_METHODS.map(m => ({ ...m, name: getPaymentMethodsName(m.value) }))
export const getSocialTypes = () => SOCIAL_TYPES.map(s => ({ ...s, name: getSocialTypesName(s.value) }))
export const getCountriesForAddress = () => COUNTRIES_FOR_ADDRESS.map(c => ({ ...c, name: configName('countries', c.value, c.value) }))
export const getCountriesForCompany = () => COUNTRIES_FOR_COMPANY.map(c => ({ ...c, name: configName('countries', c.value, c.value) }))
export const getLinkLabels = () => LINK_LABELS.map(l => ({ ...l, name: configName('linkLabels', l.key, l.key) }))
export const getCountries = () => Object.fromEntries(
  Object.keys(COUNTRIES).map(k => [k, configName('countries', k, k)])
)
